/**
 * @description 常量
 */

export const THIS_YEAR = 2022

export const WEBSITE_TI = '中国医院/医学院校科技量值'

export const TITLE = {
  main: `2023年度中国医学院校/中国医院科技量值（STEM）`,
  sub: '暨2019-2023总科技量值（ASTEM）发布',
  homeRanking: `2023年度科技量值暨五年总科技量值`
}

//机构信息
export const ORG_INFORMATION = {
  name: '中国医学科学院医学信息研究所图书馆',
  email: 'top100@imicams.ac.cn',
  address: '北京市朝阳区雅宝路3号',
  phone: ['010-52328712', '010-52328713', '010-52328714']
  // phone: '010-52328713'
}

export const ORG_REMARKS =
  '权威榜单仅在中国医学科学院医学信息研究所、中国医学科学院网站发布（<a href="http://stem.imicams.ac.cn/home">http://stem.imicams.ac.cn/home</a>)'

export const ORI_LNG_LAT = [116.438913, 39.915986]

//版权信息
export const COPYRIGHT = [
  '版权所有 中国医学科学院医学信息研究所 保留所有权利',
  'Copyright © 2014-2024 All Rights Reserved'
]

//导航
export const NAV_LIST = [
  {
    name: '首页',
    route: '/home'
  },
  // {
  //   name: 'ISTEM',
  //   route: '/ISTEM/hospital'
  // },
  // {
  //   name: '医院科技力量值',
  //   route: '/techV/hospital'
  // },
  // {
  //   name: '医学院校科技力量值',
  //   route: '/techV/university'
  // },
  {
    name: '医学院校ASTEM',
    route: '/ASTEM/college'
  },
  {
    name: '医学院校STEM',
    route: '/result/college'
  },
  {
    name: '医院ASTEM',
    route: '/ASTEM/hospital'
  },
  {
    name: '医院STEM',
    route: '/result/hospital'
  },
  {
    name: '新闻纵览',
    route: '/news'
  },
  {
    name: '精彩瞬间',
    route: '/moment'
  },
  {
    name: '评价方法',
    route: '/evaluation'
  },
  {
    name: '业务范围',
    route: '/business'
  },
  {
    name: '联系我们',
    route: '/contact'
  }
]

//相关链接
export const LINKS = [
  {
    name: '中华人民共和国国家卫生健康委员会',
    url: 'http://www.nhc.gov.cn/'
  },
  {
    name: '中华人民共和国科学技术部',
    url: 'http://www.most.gov.cn/index.html'
  },
  {
    name: '国家自然科学基金委员会',
    url: 'https://www.nsfc.gov.cn/'
  },
  {
    name: '中国医学科学院北京协和医学院',
    url: 'https://www.pumc.edu.cn/'
  }
]

//结果字段
export const TABLE_COLUMNS = [
  {
    prop: 'rank',
    name: '列位',
    align: 'center'
  },
  {
    prop: 'name',
    name: '医院',
    align: 'left'
  },
  {
    prop: 'input',
    name: '科技产出',
    align: 'center'
  },
  {
    prop: 'output',
    name: '学术影响',
    align: 'center'
  },
  {
    prop: 'influence',
    name: '科技条件',
    align: 'center'
  },
  {
    prop: 'sum',
    name: '量值',
    align: 'center'
  }
]

//ISTEM字段
export const ISTEM_TABLE_COLUMNS = [
  {
    prop: 'rank',
    name: '列位',
    align: 'center'
  },
  {
    prop: 'name',
    name: '医院',
    align: 'left'
  },
  {
    prop: 'country',
    name: '国家',
    align: 'left'
  },
  {
    prop: 'input',
    name: '科技产出',
    align: 'center'
  },
  {
    prop: 'output',
    name: '学术影响',
    align: 'center'
  },
  {
    prop: 'sum',
    name: '量值',
    align: 'center'
  }
]
//图片/视频资源路径
//export const FILE_URL = 'http://59.77.13.170:8081/file/'
//export const FILE_URL = 'http://10.33.28.53:80/file/'
export const FILE_URL = process.env.VUE_APP_BASE_API + '/file/'
// export const FILE_URL = 'http://top100.imicams.ac.cn/file/'

export default {}
